import { mesaColorNames } from '@/src/common/theme'
import { useId } from 'react'
import { Svg, Path, type SvgProps, G, Defs, ClipPath, Rect } from 'react-native-svg'

export function PaymentIcon(props: SvgProps) {
  const id = useId()
  return (
    <Svg width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
      <G clipPath={`url(#${id})`}>
        <Path
          d="M9.16667 12.4998H10.8333C11.2754 12.4998 11.6993 12.3242 12.0118 12.0117C12.3244 11.6991 12.5 11.2752 12.5 10.8332C12.5 10.3911 12.3244 9.96722 12.0118 9.65466C11.6993 9.3421 11.2754 9.1665 10.8333 9.1665H8.33333C7.83333 9.1665 7.41667 9.33317 7.16667 9.6665L2.5 14.1665"
          stroke={props.color || mesaColorNames['Mesa - Brand/Secondary #223843']}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M5.83301 17.5002L7.16634 16.3336C7.41634 16.0002 7.83301 15.8336 8.33301 15.8336H11.6663C12.583 15.8336 13.4163 15.5002 13.9997 14.8336L17.833 11.1669C18.1546 10.863 18.3423 10.4438 18.3548 10.0015C18.3673 9.55926 18.2036 9.13013 17.8997 8.80856C17.5958 8.48698 17.1766 8.2993 16.7343 8.2868C16.292 8.2743 15.8629 8.438 15.5413 8.74189L12.0413 11.9919"
          stroke={props.color || mesaColorNames['Mesa - Brand/Secondary #223843']}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M1.66699 13.3335L6.66699 18.3335"
          stroke={props.color || mesaColorNames['Mesa - Brand/Secondary #223843']}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M13.3337 9.91683C14.6683 9.91683 15.7503 8.83485 15.7503 7.50016C15.7503 6.16547 14.6683 5.0835 13.3337 5.0835C11.999 5.0835 10.917 6.16547 10.917 7.50016C10.917 8.83485 11.999 9.91683 13.3337 9.91683Z"
          stroke={props.color || mesaColorNames['Mesa - Brand/Secondary #223843']}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M5 6.6665C6.38071 6.6665 7.5 5.54722 7.5 4.1665C7.5 2.78579 6.38071 1.6665 5 1.6665C3.61929 1.6665 2.5 2.78579 2.5 4.1665C2.5 5.54722 3.61929 6.6665 5 6.6665Z"
          stroke={props.color || mesaColorNames['Mesa - Brand/Secondary #223843']}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </G>
      <Defs>
        <ClipPath id={id}>
          <Rect width="20" height="20" fill="white" />
        </ClipPath>
      </Defs>
    </Svg>
  )
}
